/* Alda home: the motion system under the hero stage.
   One personality for every direction: a smooth scroll (Lenis on native scroll, so fixed and
   sticky layers keep working), reveals that rise on power3.out and never repeat, masked line
   reveals for headlines, slow parallax on photography and floating products, and a hero stage
   that recedes into a soft card as the page takes over. Everything is declared in the markup -
   data-rv, data-px, a few named hooks - so the three pages share one vocabulary and nothing is
   animated ad hoc. Reduced motion: no smoothing, no reveals, everything simply there.

   landing.js owns the opener and the chapter bar; this file waits for its alda:landed event
   before it lets the page scroll. */
(function () {
  "use strict";
  if (!window.gsap) return;
  var gsap = window.gsap, ST = window.ScrollTrigger, SP = window.SplitText;
  if (ST) gsap.registerPlugin(ST);
  if (SP) gsap.registerPlugin(SP);
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var EASE = "power3.out", DUR = 1.15;
  var motion = !reduce && !!ST;

  // Scroll ownership is shared across all pages by smooth-scroll.js.
  function syncScrollLock() {
    if (window.aldaScroll) window.aldaScroll.syncLock();
  }
  function landed() {
    syncScrollLock();
    if (ST) ST.refresh();
    // direction A: the landed chapter bar is the house liquid glass - commerce.js maps the
    // refraction for the slab under the bar (aldaGlass); landing.css carries the material without it
    var slab = $(".hm-glass .ld-glass");
    if (slab && window.aldaGlass) window.aldaGlass.apply(slab, "bar");
  }
  if (document.documentElement.classList.contains("ld-landed")) landed();
  else document.addEventListener("alda:landed", landed, { once: true });

  /* ---------- the nav: cream over the film and the dark bands, ink over the light page ----------
     Each section declares data-nav="light|dark"; the stage counts as dark. */
  var nav = $(".ld-nav"), stage = $(".ld-stage"), navSecs = $$("[data-nav]"), navTick = false;
  function navTheme() {
    navTick = false;
    if (!nav) return;
    var r = nav.getBoundingClientRect(), y = r.top + r.height / 2, ink = true;
    if (stage && stage.getBoundingClientRect().bottom > y) ink = false;
    else {
      for (var i = 0; i < navSecs.length; i++) {
        var b = navSecs[i].getBoundingClientRect();
        if (b.top <= y && b.bottom > y) { ink = navSecs[i].getAttribute("data-nav") !== "dark"; break; }
      }
    }
    nav.classList.toggle("is-ink", ink);
  }
  window.addEventListener("scroll", function () { if (!navTick) { navTick = true; requestAnimationFrame(navTheme); } }, { passive: true });
  window.addEventListener("resize", navTheme);
  navTheme();

  /* ---------- the stage recedes ----------
     As the page takes over, the hero draws in to a soft card and lifts away - the seam between
     the film and the first section is a rounded edge and a breath of cream, not a hard cut, and
     the sheet moves with the film rather than over it. */
  if (motion && stage) {
    gsap.set(stage, { transformOrigin: "50% 50%" });
    // Keep the full-screen video on a stable compositor layer while scrolling.
    // the label and any headline over the film go first, before they would pass under the nav
    var ui = $(".ld-ui");
    if (ui) gsap.to(ui, { autoAlpha: 0, ease: "none", scrollTrigger: { trigger: stage, start: "top top", end: "35% top", scrub: true } });
  }

  /* ---------- reveals ---------- */
  function trig(el, start) { return { trigger: el, start: start || "top 88%", once: true }; }
  function split(el, kind, delay) {
    if (!SP) { gsap.from(el, { y: 30, autoAlpha: 0, duration: DUR, ease: EASE, delay: delay, scrollTrigger: trig(el) }); return; }
    SP.create(el, { type: kind === "lines" ? "lines" : "words,lines", mask: "lines", autoSplit: true, linesClass: "hm-line",
      onSplit: function (self) {
        var targets = kind === "lines" ? self.lines : self.words;
        return gsap.from(targets, { yPercent: 110, duration: 1.05, ease: EASE, delay: delay,
          stagger: kind === "lines" ? 0.09 : 0.02, scrollTrigger: trig(el) });
      } });
  }
  // late: only the reveals inside a [data-rv-late] section (revealsLate, below); otherwise every other one
  function reveals(late) {
    $$("[data-rv]").forEach(function (el) {
      if (!!el.closest("[data-rv-late]") !== !!late) return;
      var kind = el.getAttribute("data-rv"), delay = parseFloat(el.getAttribute("data-delay") || "0");
      if (kind === "up") gsap.from(el, { y: 40, autoAlpha: 0, duration: DUR, ease: EASE, delay: delay, scrollTrigger: trig(el) });
      else if (kind === "fade") gsap.from(el, { autoAlpha: 0, duration: DUR, ease: "power2.out", delay: delay, scrollTrigger: trig(el) });
      else if (kind === "img") {
        var im = el.querySelector("img, video"), tl = gsap.timeline({ delay: delay, scrollTrigger: trig(el) });
        tl.from(el, { autoAlpha: 0, scale: 0.96, duration: 1.3, ease: EASE }, 0);
        // an explicit end: a picture with its own CSS transform transition (the /care guides' hover zoom) made a from()
        // read 1.14 back as its resting scale, so the zoom never settled and cut the product at the frame (2026-10-14)
        if (im) tl.fromTo(im, { scale: 1.14 }, { scale: 1, duration: 1.7, ease: EASE }, 0);
      }
      else if (kind === "stagger") {
        var sv = { y: 40, autoAlpha: 0, duration: DUR, ease: EASE, stagger: 0.09, delay: delay, scrollTrigger: trig(el) };
        // a late section's cards hand their transform back once they are in, so the card's own hover lift works
        if (late) sv.clearProps = "transform";
        gsap.from(el.children, sv);
      }
      else if (kind === "band") gsap.from(el, { scale: 0.975, autoAlpha: 0, duration: 1.3, ease: EASE, scrollTrigger: trig(el, "top 92%") });
      else if (kind === "lines" || kind === "words") split(el, kind, delay);
      else if (kind === "floats") {
        // the stage's product settles as its cards arrive around it, corner by corner
        var hero = el.querySelector(".hmA-hero-img"), cards = $$(".hmA-float", el);
        var t2 = gsap.timeline({ scrollTrigger: trig(el, "top 78%") });
        if (hero) t2.from(hero, { y: 60, scale: 0.86, autoAlpha: 0, duration: 1.5, ease: EASE }, 0);
        t2.from(cards, { y: 46, autoAlpha: 0, duration: 1.2, ease: EASE, stagger: 0.13 }, 0.35);
      }
    });
    if (late) return;
    // a stack of cards fans out as it arrives: data-fan="rotation,x%,y%" on each card
    $$("[data-fanout]").forEach(function (root) {
      var cards = $$("[data-fan]", root);
      gsap.set(cards, { xPercent: -50, yPercent: -50, rotation: 0 });   // one stack on the centre point
      gsap.to(cards, { duration: 1.4, ease: EASE, stagger: 0.08, scrollTrigger: trig(root, "top 75%"),
        rotation: function (i, c) { return parseFloat(c.getAttribute("data-fan").split(",")[0]); },
        xPercent: function (i, c) { return -50 + parseFloat(c.getAttribute("data-fan").split(",")[1]); },
        yPercent: function (i, c) { return -50 + parseFloat(c.getAttribute("data-fan").split(",")[2]); } });
    });
    // a statement read by the scroll: words come up from a whisper as the passage crosses the fold
    $$("[data-scrub-words]").forEach(function (el) {
      gsap.fromTo($$(".w", el), { opacity: 0.16 }, { opacity: 1, stagger: 0.03, ease: "none",
        scrollTrigger: { trigger: el, start: "top 78%", end: "bottom 42%", scrub: 0.4 } });
    });
    // parallax: a photograph drifts inside its frame, a floating product against its section
    $$("[data-px]").forEach(function (el) {
      var amt = parseFloat(el.getAttribute("data-px") || "8"), host = el.closest(".hm-sec") || el.parentNode;
      gsap.fromTo(el, { yPercent: -amt }, { yPercent: amt, ease: "none",
        scrollTrigger: { trigger: el.classList.contains("hmA-hero-img") || el.classList.contains("float") || el.parentNode.classList.contains("hmB-group") ? host : el.parentNode, start: "top bottom", end: "bottom top", scrub: true } });
    });
  }
  function fanStatic() {
    // reduced motion, or no ScrollTrigger: the fan and the stack sit in their final places
    $$("[data-fan]").forEach(function (c) {
      var f = c.getAttribute("data-fan").split(",");
      gsap.set(c, { rotation: parseFloat(f[0]), xPercent: -50 + parseFloat(f[1]), yPercent: -50 + parseFloat(f[2]) });
    });
  }
  /* A section below the pinned film (marked data-rv-late: the sale band, 2026-10-12) gets its reveals after the pins.
     ScrollTrigger measures its triggers in the order they were made, so a reveal made after the pins is measured with
     their spacing in place and plays as its section arrives. (The reveals made before the pins - every data-rv below
     the showcase - are measured without it, and play before their section is on screen.) They are made
     again whenever the desktop pins are (a resize or a turn across 768px), so they always come after them. */
  function revealsLate() {
    if (!$("[data-rv-late] [data-rv]")) return;
    gsap.matchMedia().add({ wide: "(min-width: 768px)", narrow: "(max-width: 767px)" }, function () { reveals(true); });
  }
  /* The sale band's words can change for a festival (season.js, loaded by commerce.js after this file; 2026-10-13).
     Its headline is split into lines for the reveal, so the band's reveals wait until season.js has settled what the
     words are - a few seconds at most, and not at all without the band. The band sits far below the pinned film. */
  function seasonWords() {
    return new Promise(function (resolve) {
      var s = window.aldaSeason;
      if (!$("#sale [data-rv]") || (s && s.settled)) { resolve(); return; }
      var t = setTimeout(done, 4000);
      function done() { clearTimeout(t); document.removeEventListener("alda:season", on); resolve(); }
      function on(e) { if (!e.detail || e.detail.settled !== false) done(); }
      document.addEventListener("alda:season", on);
    });
  }
  if (motion) {
    // SplitText measures lines, so it waits for the display face
    var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    ready.then(function () { reveals(); homeD(); ST.refresh(); return seasonWords(); }).then(function () { revealsLate(); ST.refresh(); });
  } else { fanStatic(); homeD(); }

  /* ---------- marquee: one run set twice, slid by half and wrapped; scrolling hurries it ---------- */
  $$(".hm-marquee .track").forEach(function (track) {
    if (!motion) return;
    var tween = gsap.to(track, { xPercent: -50, duration: 32, ease: "none", repeat: -1 });
    var speed = { v: 1 };
    ST.create({ trigger: track, start: "top bottom", end: "bottom top",
      onToggle: function (s) { if (s.isActive) tween.play(); else tween.pause(); } });
    ST.create({ onUpdate: function (s) {
      speed.v = 1 + Math.min(Math.abs(s.getVelocity()) / 800, 3);
      tween.timeScale(speed.v);
      gsap.to(speed, { v: 1, duration: 1.4, ease: "power2.out", overwrite: true, onUpdate: function () { tween.timeScale(speed.v); } });
    } });
  });

  /* ---------- accordions: native details, the height eased ---------- */
  $$("details.hm-acc-item").forEach(function (d) {
    var sum = $("summary", d), body = $(".hm-acc-body", d);
    if (!sum || !body || reduce) return;
    sum.addEventListener("click", function (e) {
      e.preventDefault();
      if (d.open) {
        gsap.to(body, { height: 0, duration: 0.45, ease: "power2.inOut", onComplete: function () { d.open = false; body.style.height = ""; } });
      } else {
        d.open = true;
        gsap.fromTo(body, { height: 0 }, { height: "auto", duration: 0.6, ease: EASE, clearProps: "height" });
      }
    });
  });

  /* ---------- rotators: quotes stepped by the arrows, one at a time ---------- */
  $$("[data-rotator]").forEach(function (root) {
    var items = $$("[data-item]", root), n = $(".ctr .n", root), i = 0, busy = false;
    if (items.length < 2) return;
    function pad(k) { return (k < 10 ? "0" : "") + k; }
    function show(next) {
      next = (next + items.length) % items.length;
      if (busy || next === i) return;
      busy = true;
      var out = items[i], inn = items[next];
      i = next;
      if (n) n.textContent = pad(i + 1);
      var swap = function () {
        out.hidden = true; inn.hidden = false;
        if (reduce) { busy = false; return; }
        gsap.fromTo(inn, { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: 0.6, ease: EASE, onComplete: function () { busy = false; } });
      };
      if (reduce) swap();
      else gsap.to(out, { autoAlpha: 0, y: -10, duration: 0.3, ease: "power2.in", onComplete: swap });
    }
    var prev = $("[data-prev]", root), next = $("[data-next]", root);
    if (prev) prev.addEventListener("click", function () { show(i - 1); });
    if (next) next.addEventListener("click", function () { show(i + 1); });
  });

  /* ---------- the shop strip: arrows page it by one card ---------- */
  $$("[data-strip]").forEach(function (root) {
    var strip = $(".hmC-strip", root), prev = $("[data-strip-prev]", root), next = $("[data-strip-next]", root);
    if (!strip) return;
    function step(dir) {
      var card = strip.firstElementChild, w = card ? card.getBoundingClientRect().width + 14 : 300;
      strip.scrollBy({ left: dir * w * 2, behavior: reduce ? "auto" : "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
  });

  /* ---------- the navbars ----------
     One shelf, three doors: a mega panel under the bar (A), a full-screen curtain (B), a drawer
     that pushes the page aside (C). Each opens on one timeline and closes on its reverse, holds
     the page while it is open (the panel closes on scroll instead), and closes on Escape or the
     scrim. Nothing opens while the opener is still running. */
  var menuOpen = null, openScrollY = 0;
  function opening() { return document.body.classList.contains("ac-opening"); }
  function lockScroll(on) {
    if (window.aldaLenis) { if (on) window.aldaLenis.stop(); else window.aldaLenis.start(); }
    document.documentElement.classList.toggle("mn-open", on);
  }
  function navOpen(on) { if (nav) { nav.classList.toggle("is-open", on); if (!on) navTheme(); } }
  function focusFirst(root) {
    var f = root.querySelector("a[href], button:not([disabled])");
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { /* older engines */ } }
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && menuOpen) menuOpen.close(); });
  $$("[data-mn-close]").forEach(function (s) { s.addEventListener("click", function () { if (menuOpen) menuOpen.close(); }); });

  // A - the mega panel: hover with intent or click a category; the pane swaps while it is open
  (function mega() {
    var panel = $(".mn-mega"), scrim = $(".mn-scrim"), links = $$(".mn-link, .mn-shop"), panes = $$(".mn-pane"), tabs = $$(".mn-tab");
    if (!panel || !links.length || !nav) return;
    var open = false, cur = null, hoverT = null, closeT = null, tl = null, openedAt = 0;
    function items(p) { return $$(".hm-eyebrow, .mn-sub, .hm-btn", p); }
    function pane(key, animate) {
      if (cur === key) return;
      var prev = cur; cur = key;
      links.forEach(function (l) { l.classList.toggle("is-on", l.getAttribute("data-mega") === key); l.setAttribute("aria-expanded", String(open && l.getAttribute("data-mega") === key)); });
      tabs.forEach(function (t) { t.classList.toggle("is-on", t.getAttribute("data-mega") === key); });
      panes.forEach(function (p) {
        var on = p.getAttribute("data-pane") === key;
        p.hidden = !on;
        if (on && animate && prev !== null && !reduce) gsap.fromTo(p, { autoAlpha: 0, y: 8 }, { autoAlpha: 1, y: 0, duration: 0.3, ease: EASE });
      });
    }
    function show(key) {
      clearTimeout(closeT);
      if (opening()) return;
      pane(key, open);
      if (open) return;
      open = true; openedAt = Date.now(); openScrollY = window.scrollY; menuOpen = api; navOpen(true);
      links.forEach(function (l) { l.setAttribute("aria-expanded", String(l.getAttribute("data-mega") === key)); });
      panel.hidden = false; scrim.hidden = false;
      var p = panes.filter(function (x) { return !x.hidden; })[0];
      if (reduce) { gsap.set([panel, scrim], { autoAlpha: 1, clearProps: "y,clipPath" }); focusFirst(panel); return; }
      if (tl) tl.kill();
      tl = gsap.timeline({ onComplete: function () { focusFirst(panel); } });
      tl.fromTo(scrim, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.35 }, 0);
      tl.fromTo(panel, { autoAlpha: 0, y: -14, clipPath: "inset(0 0 100% 0 round 32px)" }, { autoAlpha: 1, y: 0, clipPath: "inset(0 0 0% 0 round 32px)", duration: 0.6, ease: EASE }, 0);
      if (p) {
        tl.fromTo(items(p), { y: 14, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5, ease: EASE, stagger: 0.04, clearProps: "all" }, 0.18);
        tl.fromTo($$(".hm-frame", p), { autoAlpha: 0, scale: 0.97 }, { autoAlpha: 1, scale: 1, duration: 0.6, ease: EASE, stagger: 0.06, clearProps: "all" }, 0.2);
      }
    }
    function close() {
      if (!open) return;
      open = false; menuOpen = null; navOpen(false);
      links.forEach(function (l) { l.classList.remove("is-on"); l.setAttribute("aria-expanded", "false"); });
      var done = function () { panel.hidden = true; scrim.hidden = true; cur = null; };
      if (reduce) { done(); return; }
      if (tl) tl.kill();
      tl = gsap.timeline({ onComplete: done });
      tl.to(panel, { autoAlpha: 0, y: -8, duration: 0.28, ease: "power2.in" }, 0);
      tl.to(scrim, { autoAlpha: 0, duration: 0.28 }, 0);
    }
    var api = { close: close };
    links.forEach(function (l) {
      var key = l.getAttribute("data-mega");
      if (!l.classList.contains("mn-shop")) {
        l.addEventListener("mouseenter", function () { clearTimeout(closeT); clearTimeout(hoverT); hoverT = setTimeout(function () { show(key); }, 110); });
        l.addEventListener("mouseleave", function () { clearTimeout(hoverT); });
      }
      l.addEventListener("click", function () {
        clearTimeout(hoverT);
        if (open && cur === key && Date.now() - openedAt > 450) close(); else show(key);
      });
    });
    tabs.forEach(function (t) { t.addEventListener("click", function () { pane(t.getAttribute("data-mega"), true); }); });
    [nav, panel].forEach(function (el) {
      el.addEventListener("mouseleave", function () { clearTimeout(closeT); closeT = setTimeout(close, 320); });
      el.addEventListener("mouseenter", function () { clearTimeout(closeT); });
    });
    window.addEventListener("scroll", function () { if (open && Math.abs(window.scrollY - openScrollY) > 60) close(); }, { passive: true });
  })();

  // B - the curtain: drops over the page; the rows hover the visual to their picture
  (function curtain() {
    var cur = $(".mn-curtain"), btn = $(".mn-toggle");
    if (!cur || !btn || !nav) return;
    var rows = $$(".mn-row", cur), vis = $$(".mn-visual img", cur), cap = $(".mn-visual .cap", cur), foot = $(".mn-foot", cur), frame = $(".mn-visual .hm-frame", cur);
    var open = false, tl = null;
    function setVis(key) {
      vis.forEach(function (v) { v.classList.toggle("is-on", v.getAttribute("data-vis") === key); });
      var row = rows.filter(function (r) { return r.getAttribute("data-img") === key; })[0];
      if (cap) cap.textContent = row ? row.getAttribute("data-cap") : "";
    }
    rows.forEach(function (r) { r.addEventListener("mouseenter", function () { setVis(r.getAttribute("data-img")); }); r.addEventListener("focusin", function () { setVis(r.getAttribute("data-img")); }); });
    function show() {
      if (open || opening()) return;
      open = true; menuOpen = api; lockScroll(true); navOpen(true);
      cur.hidden = false; btn.setAttribute("aria-expanded", "true"); btn.classList.add("is-x"); $(".w", btn).textContent = "close";
      if (rows[0]) setVis(rows[0].getAttribute("data-img"));
      if (reduce) { gsap.set(cur, { clearProps: "all" }); focusFirst(cur); return; }
      if (tl) tl.kill();
      tl = gsap.timeline({ onComplete: function () { focusFirst(cur); } });
      tl.fromTo(cur, { yPercent: -100 }, { yPercent: 0, duration: 0.8, ease: "power4.inOut" }, 0);
      // everything the close faded comes back explicitly, so a second opening is the first
      tl.fromTo(rows, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.8, ease: EASE, stagger: 0.09, clearProps: "all" }, 0.42);
      if (frame) tl.fromTo(frame, { clipPath: "inset(0 0 100% 0 round 24px)", autoAlpha: 1 }, { clipPath: "inset(0 0 0% 0 round 24px)", autoAlpha: 1, duration: 0.9, ease: EASE, clearProps: "opacity,visibility" }, 0.5);
      tl.fromTo([cap, foot].filter(Boolean), { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, clearProps: "all" }, 0.9);
    }
    function close() {
      if (!open) return;
      open = false; menuOpen = null;
      btn.setAttribute("aria-expanded", "false"); btn.classList.remove("is-x"); $(".w", btn).textContent = "menu";
      var done = function () { cur.hidden = true; lockScroll(false); navOpen(false); try { btn.focus({ preventScroll: true }); } catch (e) { /* older engines */ } };
      if (reduce) { done(); return; }
      if (tl) tl.kill();
      tl = gsap.timeline({ onComplete: done });
      tl.to([rows, frame, cap, foot].filter(Boolean), { autoAlpha: 0, duration: 0.25, ease: "power2.in" }, 0);
      tl.to(cur, { yPercent: -100, duration: 0.65, ease: "power4.inOut" }, 0.1);
    }
    var api = { close: close };
    btn.addEventListener("click", function () { if (open) close(); else show(); });
  })();

  // C - the drawer: slides in from the right and pushes the page; the categories open like an accordion
  (function drawer() {
    var dr = $(".mn-drawer"), btn = $(".mn-burger"), scrim = $(".mn-scrim");
    if (!dr || !btn || !nav) return;
    var page = $(".hm-page"), cats = $$(".mn-cat", dr), tiles = $$(".mn-tiles .hm-frame", dr), foot = $(".mn-foot", dr);
    var open = false, tl = null;
    function show() {
      if (open || opening()) return;
      open = true; menuOpen = api; lockScroll(true); navOpen(true);
      dr.hidden = false; if (scrim) scrim.hidden = false;
      btn.setAttribute("aria-expanded", "true"); btn.classList.add("is-x");
      if (reduce) { gsap.set([dr, scrim].filter(Boolean), { autoAlpha: 1, clearProps: "x,xPercent" }); focusFirst(dr); return; }
      if (tl) tl.kill();
      tl = gsap.timeline({ onComplete: function () { focusFirst(dr); } });
      if (scrim) tl.fromTo(scrim, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 }, 0);
      tl.fromTo(dr, { xPercent: 100 }, { xPercent: 0, duration: 0.75, ease: "power4.out" }, 0);
      if (page) tl.to(page, { x: "-5vw", duration: 0.75, ease: "power4.out" }, 0);
      tl.fromTo(cats.map(function (c) { return c.parentNode; }), { x: 40, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: 0.6, ease: EASE, stagger: 0.07, clearProps: "all" }, 0.25);
      tl.fromTo(tiles, { y: 24, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.6, ease: EASE, stagger: 0.06, clearProps: "all" }, 0.4);
      if (foot) tl.fromTo(foot, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4, clearProps: "all" }, 0.6);
    }
    function close() {
      if (!open) return;
      open = false; menuOpen = null;
      btn.setAttribute("aria-expanded", "false"); btn.classList.remove("is-x");
      var done = function () { dr.hidden = true; if (scrim) scrim.hidden = true; lockScroll(false); navOpen(false); try { btn.focus({ preventScroll: true }); } catch (e) { /* older engines */ } };
      if (reduce) { if (page) gsap.set(page, { clearProps: "x" }); done(); return; }
      if (tl) tl.kill();
      tl = gsap.timeline({ onComplete: done });
      tl.to(dr, { xPercent: 100, duration: 0.55, ease: "power3.inOut" }, 0);
      if (page) tl.to(page, { x: 0, duration: 0.55, ease: "power3.inOut", clearProps: "x" }, 0);
      if (scrim) tl.to(scrim, { autoAlpha: 0, duration: 0.45 }, 0.05);
    }
    var api = { close: close };
    btn.addEventListener("click", function () { if (open) close(); else show(); });
    cats.forEach(function (c) {
      var body = c.nextElementSibling;
      c.addEventListener("click", function () {
        var on = c.getAttribute("aria-expanded") === "true";
        cats.forEach(function (o) {
          if (o !== c && o.getAttribute("aria-expanded") === "true") { o.setAttribute("aria-expanded", "false"); gsap.to(o.nextElementSibling, { height: 0, duration: reduce ? 0 : 0.4, ease: "power2.inOut" }); }
        });
        c.setAttribute("aria-expanded", String(!on));
        gsap.to(body, { height: on ? 0 : "auto", duration: reduce ? 0 : (on ? 0.4 : 0.55), ease: on ? "power2.inOut" : EASE });
      });
    });
    var cartBtn = $("[data-cart]", dr);
    if (cartBtn) cartBtn.addEventListener("click", function () { close(); var pill = $(".ac-cartpill"); if (pill) pill.click(); });
  })();

  /* ---------- cook by dish: the dish list is a tablist that drives one panel ----------
     (home_dish.py) Click or arrow keys choose a dish; the photograph, line and cards change together. */
  $$("[data-dish]").forEach(function (root) {
    var tabs = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root);
    function show(i, focus) {
      tabs.forEach(function (t, j) { var on = j === i; t.classList.toggle("is-on", on); t.setAttribute("aria-selected", String(on)); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p, j) { var on = j === i; p.classList.toggle("is-on", on); if (on) p.removeAttribute("aria-hidden"); else p.setAttribute("aria-hidden", "true"); });
      if (focus) tabs[i].focus();
      if (tabs[i].scrollIntoView && window.matchMedia("(max-width: 767px)").matches) tabs[i].scrollIntoView({ block: "nearest", inline: "center", behavior: reduce ? "auto" : "smooth" });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { show(i); });
      t.addEventListener("keydown", function (e) {
        var n = tabs.length, k = e.key;
        var j = k === "ArrowDown" || k === "ArrowRight" ? (i + 1) % n : k === "ArrowUp" || k === "ArrowLeft" ? (i - 1 + n) % n : k === "Home" ? 0 : k === "End" ? n - 1 : -1;
        if (j < 0) return;
        e.preventDefault();
        show(j, true);
      });
    });
  });

  /* ---------- quick add: one size goes straight in; more sizes are chosen first ----------
     (2026-09-28: the "+" used to add the hero size without saying which.) On a desktop up to four
     sizes open as chips over the photograph and more as a list there; a phone always gets a bottom
     sheet. The cart drawer opening is the confirmation, as it is everywhere else. */
  (function () {
    function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
    function rupees(n) { return "₹" + Number(n).toLocaleString("en-IN"); }
    function pretty(label) { return String(label).replace(" - ", " · "); }
    function phone() { return window.matchMedia("(max-width: 767px)").matches; }
    // a size's selling price: its sale price when it has one (commerce.js window.aldaPrice; the same rule here in
    // case this ever runs first)
    function sell(v) { return window.aldaPrice ? window.aldaPrice.price(v) : (v.sale && v.sale < v.mrp ? v.sale : v.mrp); }
    function put(b, v) {
      var d = b.dataset;
      if (window.aldaCart) return window.aldaCart.add({ slug: d.slug, name: d.name, label: v.label, mrp: v.mrp, price: sell(v), img: d.img });
      window.location.href = "/products/" + d.slug;
    }
    // the price inside an option: the selling price, and on sale the struck MRP beside it
    function priceEl(v) {
      var p = el("span", "p");
      if (window.aldaPrice) p.appendChild(window.aldaPrice.node(v));
      else p.textContent = rupees(sell(v));
      return p;
    }
    function option(cls, b, v, done) {
      var o = el("button", cls);
      o.type = "button";
      o.appendChild(el("span", "l", pretty(v.label)));
      // sold out (commerce.js window.aldaStock): the size stays in the list, switched off, saying so
      if (window.aldaStock && window.aldaStock.out(b.dataset.slug, v.label)) {
        o.appendChild(el("span", "p is-out", window.aldaStock.text));
        o.disabled = true;
        o.classList.add("is-out");
        o.setAttribute("aria-label", b.dataset.name + ", " + v.label + ", " + window.aldaStock.text.toLowerCase());
        return o;
      }
      o.appendChild(priceEl(v));
      o.setAttribute("aria-label", "Add " + b.dataset.name + ", " + v.label + ", " + rupees(sell(v)) +
        (sell(v) < v.mrp ? ", MRP " + rupees(v.mrp) : ""));
      o.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); done(); put(b, v); });
      return o;
    }
    /* The sizes baked into a card (data-variants) are a snapshot of the catalogue at build time. When a chooser
       opens it checks them against the page's catalogue (commerce.js aldaCart.catalogue, one shared fetch) and
       redraws its options if a sale started, changed or ended since - so it never quotes a price the cart won't. */
    function syncSizes(b, vars, redraw) {
      if (b._synced || !window.aldaCart || !window.aldaCart.catalogue) return;
      b._synced = true;
      window.aldaCart.catalogue().then(function (cat) {
        var f = cat && cat.fams[b.dataset.slug], changed = false;
        if (!f) return;
        vars.forEach(function (v) {
          var c = f.variants.filter(function (x) { return x.label === v.label; })[0];
          if (!c || (c.mrp === v.mrp && (c.sale || 0) === (v.sale || 0))) return;
          v.mrp = c.mrp;
          if (c.sale) v.sale = c.sale; else delete v.sale;
          changed = true;
        });
        if (changed) redraw();
      });
    }

    var openCard = null;
    function closeCard(focusBack) {
      if (!openCard) return;
      var b = $(".hm-add", openCard);
      openCard.classList.remove("is-sizing");
      b.setAttribute("aria-expanded", "false");
      if (focusBack) b.focus();
      openCard = null;
    }

    // the phone sheet: one element, filled for whichever card opened it
    var sheet = null, sheetFor = null;
    function buildSheet() {
      sheet = el("div", "hm-sheet");
      sheet.setAttribute("role", "dialog");
      sheet.setAttribute("aria-modal", "true");
      sheet.setAttribute("aria-label", "Choose a size");
      var scrim = el("div", "hm-sheet-scrim");
      scrim.addEventListener("click", function () { closeSheet(true); });
      var panel = el("div", "hm-sheet-panel"), head = el("div", "hm-sheet-head"), tx = el("div", "hm-sheet-tx");
      sheet._img = el("img", "hm-sheet-img");
      sheet._img.alt = "";
      sheet._name = el("p", "hm-sheet-n");
      tx.appendChild(el("p", "hm-sheet-k", "Choose a size"));
      tx.appendChild(sheet._name);
      var x = el("button", "hm-sheet-x", "×");
      x.type = "button";
      x.setAttribute("aria-label", "Close");
      x.addEventListener("click", function () { closeSheet(true); });
      head.appendChild(sheet._img); head.appendChild(tx); head.appendChild(x);
      sheet._opts = el("div", "hm-sheet-opts");
      panel.appendChild(head); panel.appendChild(sheet._opts);
      sheet.appendChild(scrim); sheet.appendChild(panel);
      document.body.appendChild(sheet);
    }
    function fillSheet(b, vars) {
      sheet._opts.replaceChildren();
      vars.forEach(function (v) { sheet._opts.appendChild(option("hm-size-row", b, v, function () { closeSheet(false); })); });
    }
    function openSheet(b, vars) {
      if (!sheet) buildSheet();
      sheetFor = b;
      sheet._img.src = b.dataset.img;
      sheet._name.textContent = b.dataset.name;
      fillSheet(b, vars);
      syncSizes(b, vars, function () {
        if (sheetFor !== b) return;
        // keep the keyboard where it was: a redraw replaces the focused row
        var at = Array.prototype.indexOf.call(sheet._opts.children, document.activeElement);
        fillSheet(b, vars);
        if (at > -1 && sheet._opts.children[at]) sheet._opts.children[at].focus({ preventScroll: true });
      });
      sheet.classList.add("is-on");
      if (window.aldaLenis) window.aldaLenis.stop();
      var first = sheet._opts.firstChild;
      if (first) first.focus({ preventScroll: true });
    }
    function closeSheet(focusBack) {
      if (!sheet || !sheet.classList.contains("is-on")) return;
      sheet.classList.remove("is-on");
      if (window.aldaLenis) window.aldaLenis.start();
      if (focusBack && sheetFor) sheetFor.focus({ preventScroll: true });
      sheetFor = null;
    }

    $$("[data-add]").forEach(function (b) {
      var d = b.dataset, vars = null;
      try { vars = JSON.parse(d.variants || "null"); } catch (err) { vars = null; }
      // no size list: the card's one size, its selling price in data-price when that is below the MRP
      if (!vars || !vars.length) {
        vars = [{ label: d.label, mrp: parseInt(d.mrp, 10) }];
        var dp = parseInt(d.price, 10);
        if (dp > 0 && dp < vars[0].mrp) vars[0].sale = dp;
      }
      var card = b.closest(".hm-pcard");
      if (vars.length === 1 || !card) {
        b.addEventListener("click", function (e) { e.preventDefault(); put(b, vars[0]); });
        return;
      }
      b.setAttribute("aria-label", "Choose a size of " + d.name);
      b.setAttribute("aria-haspopup", "true");
      b.setAttribute("aria-expanded", "false");
      var list = vars.length > 4;
      var panel = el("div", "hm-sizes" + (list ? " is-list" : ""));
      panel.setAttribute("role", "group");
      panel.setAttribute("aria-label", "Sizes of " + d.name);
      if (list) panel.appendChild(el("p", "hm-sizes-k", "Choose a size"));
      var opts = el("div", "hm-sizes-opts");
      function fillChips() {
        opts.replaceChildren();
        vars.forEach(function (v) { opts.appendChild(option("hm-size", b, v, function () { closeCard(false); })); });
      }
      fillChips();
      panel.appendChild(opts);
      card.appendChild(panel);
      b.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (phone()) { closeCard(false); openSheet(b, vars); return; }   // phone cards are too narrow for chips
        var same = openCard === card;
        closeCard(false);
        if (same) return;
        syncSizes(b, vars, function () {
          // keep the keyboard where it was: a redraw replaces the focused chip
          var at = Array.prototype.indexOf.call(opts.children, document.activeElement);
          fillChips();
          if (at > -1 && opts.children[at]) opts.children[at].focus({ preventScroll: true });
        });
        openCard = card;
        card.classList.add("is-sizing");
        b.setAttribute("aria-expanded", "true");
        var first = $(".hm-size", panel);
        if (first) first.focus({ preventScroll: true });
      });
    });
    document.addEventListener("click", function (e) { if (openCard && !openCard.contains(e.target)) closeCard(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (sheet && sheet.classList.contains("is-on")) closeSheet(true); else closeCard(true);
    });
  })();

  /* Direction D: the pan showcase and frame film are the two scroll-driven moments.
     Other sections flow naturally, with shared reveals and the sticky materials photograph.
     The showcase pin is desktop-only; the film also scrubs on mobile. */
  function homeD() {
    var mm = gsap.matchMedia();

    // the word rotator: the words stack on one spot, masked; one turns over every few seconds
    $$("[data-word-rotator]").forEach(function (root) {
      var ws = $$(".w", root), i = 0, timer = null;
      if (ws.length < 2) return;
      var widths = [];
      function fit() {
        // the slot is as wide as the word in it, so the full stop stays on the word
        widths = ws.map(function (x) { return Math.ceil(x.getBoundingClientRect().width); });
        root.style.width = widths[i] + "px";
      }
      gsap.set(ws, { yPercent: function (k) { return k ? 100 : 0; }, autoAlpha: function (k) { return k ? 0 : 1; } });
      fit();
      window.addEventListener("resize", fit);
      if (!motion) return;
      function turn() {
        var out = ws[i]; i = (i + 1) % ws.length;
        gsap.to(root, { width: widths[i], duration: 0.6, ease: "power3.inOut" });
        gsap.to(out, { yPercent: -100, autoAlpha: 0, duration: 0.55, ease: "power3.in" });
        gsap.fromTo(ws[i], { yPercent: 100, autoAlpha: 0 }, { yPercent: 0, autoAlpha: 1, duration: 0.7, ease: "power3.out", delay: 0.3 });
      }
      function run(on) { if (on && !timer) timer = setInterval(turn, 2400); else if (!on && timer) { clearInterval(timer); timer = null; } }
      ST.create({ trigger: root, start: "top bottom", end: "bottom top", onToggle: function (s) { run(s.isActive); } });
    });

    // the showcase: pinned for two screens; the pan scales up, the cards arrive and drift at their depths
    $$("[data-scrub-scale]").forEach(function (stage) {
      var img = $(".hmD-show-img", stage), cards = $$(".hmD-show-card", stage), copy = $(".hmD-show-copy", stage), buy = $(".hmD-show-buy", stage);
      if (img) gsap.set(img, { xPercent: -50, yPercent: -50 });
      if (!motion) return;
      mm.add("(min-width: 768px)", function () {
        var tl = gsap.timeline({ scrollTrigger: { trigger: stage.closest(".hm-sec"), start: "top top", end: "+=140%", pin: true, scrub: 0.6, anticipatePin: 1 } });
        if (img) tl.fromTo(img, { scale: 0.55 }, { scale: 1.08, duration: 1, ease: "none" }, 0);
        if (copy) tl.to(copy, { autoAlpha: 0, y: -40, duration: 0.28, ease: "none" }, 0.06);
        cards.forEach(function (c, k) {
          tl.fromTo(c, { autoAlpha: 0, scale: 0.92 }, { autoAlpha: 1, scale: 1, duration: 0.16, ease: "none" }, 0.3 + k * 0.1);

        });
        if (buy) tl.fromTo(buy, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 0.14, ease: "none" }, 0.82);
      });
    });

    // the materials: whichever block holds the middle of the screen owns the sticky photograph
    $$("[data-swap]").forEach(function (root) {
      var pics = $$(".stack > *", root), blks = $$(".blk", root);
      if (!ST || !blks.length) return;
      function on(key) {
        pics.forEach(function (p) { p.classList.toggle("is-on", p.getAttribute("data-key") === key); });
        blks.forEach(function (b) { b.classList.toggle("is-on", b.getAttribute("data-key") === key); });
      }
      blks.forEach(function (b) {
        ST.create({ trigger: b, start: "top 55%", end: "bottom 55%",
          onEnter: function () { on(b.getAttribute("data-key")); }, onEnterBack: function () { on(b.getAttribute("data-key")); } });
      });
    });

    // three layers: each stroke is drawn as the screen arrives, its label following
    $$("[data-draw]").forEach(function (fig) {
      var paths = $$("path.p", fig), labs = $$(".lab", fig);
      paths.forEach(function (p) { var L = p.getTotalLength(); p.style.strokeDasharray = L; p.style.strokeDashoffset = L; });
      if (!motion) { paths.forEach(function (p) { p.style.strokeDashoffset = 0; }); return; }
      var tl = gsap.timeline({ scrollTrigger: { trigger: fig.closest(".hm-sec"), start: "top 85%", end: "top 5%", scrub: 0.6 } });
      paths.forEach(function (p, k) {
        tl.to(p, { strokeDashoffset: 0, duration: 0.3, ease: "none" }, k * 0.22);
        if (labs[k]) tl.fromTo(labs[k], { autoAlpha: 0, x: -10 }, { autoAlpha: 1, x: 0, duration: 0.12, ease: "none" }, k * 0.22 + 0.18);
      });
    });

    // the film: clips cut to frames (scratchpad/cut_film.py), scrubbed on a pinned canvas. Progress
    // maps to a frame through each segment's weight, so the short construction clip gets the slow
    // scrub; the two nearest frames are blended by the fraction between them, and the scrub itself
    // lags the scroll a little, which is what makes it feel like film rather than a slideshow.
    // Each scene carries one short phrase, faded as a whole without additional navigation.
    $$("[data-film]").forEach(function (stage) {
      var canvas = $("canvas", stage), sec = stage.closest(".hm-sec");
      if (!canvas || !ST) return;
      var ctx = canvas.getContext("2d");
      var mobile = window.innerWidth < 768;
      // Portrait screens get the square phone frames (scratchpad/bake_film_phone.py), already cut around
      // the product; a 16:9 frame cover-cropped into a tall stage left a sliver of mostly black.
      var box0 = stage.getBoundingClientRect();
      var square = box0.height > box0.width * 1.1 && !!stage.getAttribute("data-film-m");
      stage.classList.toggle("is-square", square);
      var tpl = stage.getAttribute(square ? "data-film-m" : "data-film");
      var n = parseInt(stage.getAttribute("data-count"), 10) || 0;
      var map = JSON.parse(stage.getAttribute("data-map") || "[]");
      var sceneP = JSON.parse(stage.getAttribute("data-scenes") || "[0]");
      var caps = $$(".cap", stage);
      if (!n || !map.length) return;
      var imgs = new Array(n), ready = new Array(n), pos = 0, lastKey = "", dpr = 1;
      var active = false, queue = [], pendingFrames = {}, inFlight = 0;

      function src(i) { var s = String(i); while (s.length < 3) s = "0" + s; return tpl.replace("{i}", s); }
      function pump() {
        if (!active) return;
        while (inFlight < 4 && queue.length) {
          var i = queue.shift(); delete pendingFrames[i];
          if (imgs[i]) continue;
          (function (index) {
            var im = new Image(); im.decoding = "async"; imgs[index] = im; inFlight++;
            im.onload = function () { inFlight--; ready[index] = true;
              var centre=Math.round(frameAt(pos));
              for(var old=0;old<n;old++)if(ready[old]&&Math.abs(old-centre)>24){imgs[old]=null;ready[old]=false;}
              requestDraw(); pump(); };
            im.onerror = function () { inFlight--; pump(); };
            im.src = src(index);
          })(i);
        }
      }
      function load(i) {
        if (!active || i < 0 || i >= n || !map.some(function(m){return i>=m.from && i<=m.to;}) || imgs[i] || pendingFrames[i]) return;
        pendingFrames[i] = true; queue.push(i);
      }
      function nearest(i) {
        for (var d = 0; d < n; d++) { if (ready[i - d]) return i - d; if (ready[i + d]) return i + d; }
        return -1;
      }
      // progress -> fractional frame, through the segments' weights
      function frameAt(p) {
        var cum = 0;
        for (var k = 0; k < map.length; k++) {
          var m = map[k], span = m.to - m.from + 1;
          if (p <= cum + m.w || k === map.length - 1) return Math.min(m.to, m.from + Math.max(0, (p - cum) / m.w) * (span - 1));
          cum += m.w;
        }
        return n - 1;
      }
      function size() {
        var r = canvas.getBoundingClientRect();
        dpr = Math.min(window.devicePixelRatio || 1, mobile ? 2 : 1.5);
        canvas.width = Math.max(1, Math.round(r.width * dpr)); canvas.height = Math.max(1, Math.round(r.height * dpr));
        lastKey = ""; draw();
      }
      function cover(im, alpha) {
        var fw = im.naturalWidth, fh = im.naturalHeight;
        if (!fw || !fh) return;
        var cw = canvas.width, ch = canvas.height, s, dw, dh;
        ctx.globalAlpha = alpha;
        if (square) {
          // The square frame spans the width a little above centre; its feathered top and bottom
          // meet the black stage, and the caption sits in the black beneath it.
          s = cw / fw; dw = cw; dh = fh * s;
          ctx.drawImage(im, 0, dh < ch ? Math.min(Math.max(ch * 0.4 - dh / 2, 0), ch - dh) : (ch - dh) / 2, dw, dh);
          return;
        }
        // Full-bleed frame; captions occupy the negative space authored into each scene.
        s = Math.max(cw / fw, ch / fh); dw = fw * s; dh = fh * s;
        // Narrow landscape windows keep the product in view: the tri-ply wall is left of centre, the cooker right.
        var anchor = window.innerWidth < 768 ? (stage.classList.contains("is-image-left") ? 0.1 : 0.62) : 0.5;
        ctx.drawImage(im, (cw - dw) * anchor, (ch - dh) / 2, dw, dh);
      }
      var drawQueued=false;
      function requestDraw(){if(drawQueued)return;drawQueued=true;requestAnimationFrame(function(){drawQueued=false;draw();});}
      function draw() {
        var f = frameAt(pos), a = Math.round(f), b = a, t = 0;
        // Construction starts with the pot on the right, then reveals layers on the left.
        // Follow that internal shot change, rather than assigning one side to the entire scene.
        stage.classList.toggle("is-image-left", f >= 86 && f < 117);
        if (active) {
          // Discard stale queued work after a fast scroll; prioritize the current frame.
          queue = []; pendingFrames = {};
          load(a); load(b);
          if (motion) for (var q = 1; q <= 10; q++) { load(a + q); load(a - q); }
          pump();
        }
        var ia = nearest(a), ib = nearest(b);
        if (ia < 0) return;
        var key = ia + ":" + ib + ":" + t.toFixed(2) + ":" + canvas.width;
        if (key === lastKey) return;
        lastKey = key;
        ctx.globalAlpha = 1; ctx.fillStyle = "#000"; ctx.fillRect(0, 0, canvas.width, canvas.height);
        cover(imgs[ia], 1);
        if (ib !== ia && t > 0.01) cover(imgs[ib], t);
        ctx.globalAlpha = 1;
      }
      // Start frame requests only as the scene approaches the viewport.
      if ('IntersectionObserver' in window) {
        var filmObserver = new IntersectionObserver(function (entries) {
          active = entries[0].isIntersecting;
          if (active) draw();
        }, { rootMargin: '100% 0px' });
        filmObserver.observe(sec);
      } else { active = true; }
      size();
      window.addEventListener("resize", size);

      // Phones skip the film (the user's call, 2026-09-28): home.css hides the section below 768px,
      // and the pin exists only above it, so no empty scroll is left behind. Resizing across the
      // breakpoint builds or reverts the pin.
      mm.add("(min-width: 768px)", function () {
        if (!motion) {
          // Reduced motion: a static closing frame and its phrase.
          pos = 1; draw();
          caps.forEach(function (c, k) { gsap.set(c, { autoAlpha: k === caps.length - 1 ? 1 : 0 }); });
          return;
        }

        var run = caps.length === 2 ? "146%" : "260%";
        var proxy = { p: 0 }, splits = [];
        var tl = gsap.timeline({ scrollTrigger: { trigger: sec, start: "top top", end: "+=" + run, pin: true, scrub: 0.9, anticipatePin: 1 } });
        tl.to(proxy, { p: 1, duration: 1, ease: "none", onUpdate: function () { pos = proxy.p; requestDraw(); } }, 0);

        // Characters brighten on the film's existing scrub timeline, then hold for reading.
        caps.forEach(function (cap, k) {
          var s0 = sceneP[k], s1 = k + 1 < sceneP.length ? sceneP[k + 1] : 1, len = s1 - s0;
          if (k === 0) gsap.set(cap, { autoAlpha: 1 });
          else tl.fromTo(cap, { autoAlpha: 0 }, { autoAlpha: 1, duration: len * 0.12, ease: "none" }, s0 + len * 0.04);
          if (k + 1 < caps.length) tl.to(cap, { autoAlpha: 0, duration: len * 0.1, ease: "none" }, s1 - len * 0.1);
          var heading = cap.querySelector("h2");
          if (SP && heading) {
            // Word wrappers preserve natural wrapping; SplitText supplies the accessible label.
            var split = new SP(heading, { type: "words,chars", aria: "auto" });
            splits.push(split);
            tl.fromTo(split.chars, { opacity: 0.24 }, {
              opacity: 1, duration: len * 0.16,
              stagger: { amount: len * 0.40 }, ease: "sine.inOut"
            }, s0 + len * 0.12);
          }
        });
        return function () { splits.forEach(function (s) { s.revert(); }); };
      });
    });

    // Local backgrounds keep pinned sections independent in both scroll directions.
    // The dark statement arrives as a rounded sheet, then opens into the page width.
    var readSection = $(".hmD-read");
    if (motion && readSection) gsap.fromTo(readSection,
      { clipPath: "inset(0 4% 0 4% round 44px)" },
      { clipPath: "inset(0 0% 0 0% round 0px)", ease: "none",
        scrollTrigger: { trigger: readSection, start: "top 95%", end: "top 45%", scrub: 0.45 } });

    // The kitchen shelf cards rise in as they arrive (restored 2026-10-04 at the user's request; they were
    // removed on 2026-09-13 while chasing a scroll flash that turned out not to be the animations).
    if (motion) $$(".ks-card").forEach(function (card) {
      gsap.fromTo(card, { y: 24, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.85, ease: "power2.out",
        scrollTrigger: { trigger: card, start: "top 94%", once: true } });
    });
    $$("[data-moment-reveal]").forEach(function (row) {
      if (!motion) return;
      var cards = $$(".hmD-moment", row);
      var tl = gsap.timeline({ scrollTrigger: { trigger: row, start: "top 85%", toggleActions: "play none none reverse" } });
      tl.fromTo(cards, { y: 70, autoAlpha: 0, clipPath: "inset(16% 0 0 0 round 24px)" },
        { y: 0, autoAlpha: 1, clipPath: "inset(0% 0 0 0 round 24px)", duration: 1.1, stagger: 0.14, ease: "power3.out" });
    });
    $$("[data-notes-reveal]").forEach(function (row) {
      if (!motion) return;
      var cards = $$(".hmD-note", row);
      var tl = gsap.timeline({ scrollTrigger: { trigger: row, start: "top 85%", toggleActions: "play none none reverse" } });
      tl.fromTo(cards, { y: 90, rotation: function (i) { return [5, -4, 3][i]; }, autoAlpha: 0, scale: 0.96 },
        { y: 0, rotation: 0, autoAlpha: 1, scale: 1, duration: 1, stagger: 0.22, ease: "power3.out" });
    });
  }
})();

// the range films: a few seconds of a shelf's film on its kitchen-shelf card, on hover; and a film in a picture frame
// (the About page's Glen section, 2026-10-14)
if(document.querySelector(".ks-grid, .hm-frame video[data-film]")){if(!document.querySelector("script[data-films]")){var fl=document.createElement("script");fl.src="https://static.aldaindia.com/alda-assets/films.js?v=ae61a0a8";fl.async=true;fl.setAttribute("data-films","");document.head.appendChild(fl);}}
if(document.querySelector(".vt-depth")){var vd=document.createElement("script");vd.src="https://static.aldaindia.com/alda-assets/depth/vitale.js?v=9dcb1b28";document.body.appendChild(vd);}

/* The About page's category cards turn through their products' photographs (2026-10-14, the user: "replace with actual
   product images from pdp. have 4-6 different products on rotation"; scratchpad/make-about-cards.py). One picture
   every 3.2s, a soft cross-fade, each card a beat after the one before so the three never change together; the next
   picture is fetched one turn ahead. Only while a card is on screen and the tab is in view; with reduced motion the
   first product stays. */
(function () {
  var cards = Array.prototype.slice.call(document.querySelectorAll("[data-turn]"));
  if (!cards.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var HOLD = 3200, BEAT = 1050;
  function fetch(im) { if (im && !im.getAttribute("src") && im.dataset.src) im.src = im.dataset.src; }
  cards.forEach(function (card, n) {
    var pics = Array.prototype.slice.call(card.querySelectorAll("img"));
    if (pics.length < 2) return;
    var at = 0, timer = null, seen = false, waiting = false;
    function turn() {
      if (waiting) return;
      var next = (at + 1) % pics.length;
      var go = function () {
        waiting = false;
        pics[at].classList.remove("is-on");
        pics[next].classList.add("is-on");
        at = next;
        fetch(pics[(at + 1) % pics.length]);
      };
      // never fade to a picture that has not arrived: wait for it (one wait at a time)
      if (pics[next].complete && pics[next].naturalWidth) go();
      else { waiting = true; fetch(pics[next]); pics[next].addEventListener("load", go, { once: true }); }
    }
    function start() { if (timer || !seen || document.hidden) return; timer = setTimeout(function tick() { turn(); timer = setTimeout(tick, HOLD); }, HOLD + n * BEAT); }
    function stop() { clearTimeout(timer); timer = null; }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        seen = es[0].isIntersecting;
        if (seen) { fetch(pics[1]); start(); } else stop();
      }, { rootMargin: "120px 0px" }).observe(card);
    } else { seen = true; fetch(pics[1]); start(); }
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else start(); });
  });
})();
